module.exports = __webpack_public_path__ + "static/media/order-icon.9043ab1c.svg";